<!--
 ** @Copyright 2025 HaiEr, All Rights Reserved.
 ** @--------------------
 ** @模块名称: 整机送样
 ** @Author: cjhgit jhcuil@outlook.com
 ** @Date: 2025-01-10 14:31:47
 * @LastEditors: cjhgit jhcuil@outlook.com
 * @LastEditTime: 2025-02-27 15:38:01
 ** @url: \sqm-element\src\components\sFolderOfDWMAS\deliverTheWholeMachineSample.vue
 -->
<template>
  <h-list-page>
    <h-card :title="h_i18n('a22da82fdca28ed11bed397e21b0c8b4')" width="100%" is-search @change-method="changeMethod" footer>
      <h-area>
        <h-search :title="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')">
          <h-input v-model="searchData.documentName" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" clearable></h-input>
        </h-search>

        <h-search :title="h_i18n('b78e5305ebcec48a0cbebdac294124e1')">
          <h-select v-model="searchData.hrTestType" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable>
            <h-option value="预验证" :label="h_i18n('ecf148b318778ec56c318c41db370100')"></h-option>
            <h-option value="整机验证" :label="h_i18n('f98d407bd359d1a88bd969bd1434ec23')"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('738f945f74701261355a9a9038aee82f')">
          <h-select v-model="searchData.statusList" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable multiple class="myMultiple75">
            <h-option value="待送样" :label="h_i18n('f1728af6ff0737b74b63d2238de7b5ca')"></h-option>
            <h-option value="待收样" :label="h_i18n('8857975c8e26bc5a5c32736bc7a24262')"></h-option>
            <h-option value="已收样" :label="h_i18n('f55ed1536d7552ac5b5af0e0ec249537')"></h-option>
            <h-option value="研发自收样" :label="h_i18n('b2a426c963841e34dae91be47d1545b9')"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('a5963b0ad197761a82940c656de9f651')">
          <h-input v-model="searchData.insProNum" clearable :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" @clear="searchClear('insProNum')"></h-input>
        </h-search>

        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete popper-class="planHidden" v-model="searchData.partNumber" :fetch-suggestions="mtlNoChange"
                          :trigger-on-focus="false" @input="() =>searchData.partNumber.length < 4? (plan.showMtlPlan = false): ''"
                          @clear="plan.showMtlPlan = false" clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')"
                          @blur="detailBlur('showMtlPlan')" @focus="detailFocus('showMtlPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" ref="filterTable" :data="data.mtlList" border size="small" max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur=true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>

        <h-search :title="h_i18n('aae11e21d2ef24d030976e023bc44ff5')">
          <h-input v-model="searchData.nomenclature" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" clearable @clear="searchClear('nomenclature')"></h-input>
        </h-search>
        <!-- <h-search label="送样计划单号">
          <h-input v-model="searchData.nomenclature" placeholder="请输入" clearable @clear="searchClear('nomenclature')"></h-input>
        </h-search> -->

        <h-search :title="h_i18n('8779e39b05444a95e96e6940f68cc309')">
          <h-input v-model="searchData.factoryCode" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" clearable  @clear="searchClear('factoryCode')"></h-input>
        </h-search>
        <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
          <h-select v-model="searchData.sybId" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable filterable>
            <h-option v-for="(item, index) in data.sybList" :key="index" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('d1d5ca31b2d76140e648bbb6cd2fe1f3')">
          <h-date-picker @change="TimeChange(data.creationDate, { start: 'beginDateCreate', end: 'endDateCreate' })" v-model="data.creationDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <h-search :title="h_i18n('44fa184da2388ae205fccc0adebec7d4')">
          <h-date-picker @change="TimeChange(data.dateCreateTime, { start: 'beginDateCreateTime', end: 'endDateCreateTime' })" v-model="data.dateCreateTime" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <h-search :title="h_i18n('3259d6eee4dc9fe574b73d7e67089ecd')">
          <h-date-picker @change="TimeChange(data.receiveDate, { start: 'receiveDateBegin', end: 'receiveDateEnd' })" v-model="data.receiveDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)">
            <template #icon>
              <search/>
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('a22da82fdca28ed11bed397e21b0c8b4')" :is-left="0" :is-right="0" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <h-button type="primary" v-if="data.btnListOfSqm.some((item)=>item.code.includes('SY'))" @click="sendBtn()">
            <template #icon><send theme="outline"/></template>{{ h_i18n('480314fec74c7ad31c65e15658d015fa') }}</h-button>
          <h-button type="default" v-if="data.btnListOfSqm.some((item)=>item.code.includes('DC'))" @click="excleBtn()">
            <template #icon><i class="iconfont icon-daochu"></i></template>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
        </h-button-group>
      </template>
      <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" v-loading="data.tableLoading" height="540" @selection-change="listCheckBoxChange"
                border :data="data.dataOfTable" size="small" style="width: 100%; min-height: 540px">
        <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="status" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="80"></el-table-column>
        <!-- <el-table-column prop="送样计划单号" label="送样计划单号" width="110"></el-table-column> -->
        <el-table-column prop="documentName" :label="h_i18n('1d2a691eda00b5b04a5911dfb42c2e22')" width="210">
          <template #default="{ row }">
            <span class="blue pointer" @click="createReceiveData(row)">{{ row.documentName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creationDate" :label="h_i18n('d1d5ca31b2d76140e648bbb6cd2fe1f3')" width="130">
          <template #default="{ row }">
            <span>{{ time(row.creationDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="factoryCode" :label="h_i18n('8779e39b05444a95e96e6940f68cc309')" width="100"></el-table-column>
        <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" width="130"></el-table-column>
        <el-table-column prop="hrTestType" :label="h_i18n('b78e5305ebcec48a0cbebdac294124e1')" width="100"></el-table-column>
        <el-table-column prop="partNumber" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130"></el-table-column>
        <el-table-column prop="nomenclature" :label="h_i18n('aae11e21d2ef24d030976e023bc44ff5')" width="200"></el-table-column>
        <el-table-column prop="supplierID" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" width="110"></el-table-column>
        <el-table-column prop="supplierName" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" width="200"></el-table-column>
        <el-table-column prop="insProNum" :label="h_i18n('34ccac3401851bd8511ddfa1988450ee')" width="130"></el-table-column>
        <el-table-column prop="prototypeSendQuant" :label="h_i18n('d784e4ded016c9373f4d1c41caae6fbe')" width="130"></el-table-column>
        <el-table-column prop="prototypeSendDate" :label="h_i18n('d7f974be4808f887a05db717fd37ea36')" width="150">
          <template #default="{ row }">
            <span>{{ time(row.prototypeSendDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="vendorSendSampleDate" :label="h_i18n('a979959a9173db24b7d2eaf0c9d86f56')" width="130">
          <template #default="{ row }">
            <span>{{ time(row.vendorSendSampleDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="vendorSendSamplePerson" :label="h_i18n('6a52ae8d38d65d94a9673129041ca156')" width="120"></el-table-column>
        <el-table-column prop="vendorSendSampleWay" :label="h_i18n('b79c2c2ca46c980cddc5577c8c7d260b')" width="120"></el-table-column>
        <el-table-column prop="expressNumber" :label="h_i18n('3c016d36581bc71c027386cbf617722f')" width="120"></el-table-column>
        <el-table-column prop="vendorSendSamplePicture" :label="h_i18n('b469069f8af868fe83bb5dbe51a51d47')" width="150">
          <template #default="{ row }">
            <div class="row_pic_style">
              <template v-for="item in getRowPicList(row)" >
                <span class="pointer blue" @click="lookPicture(item)">{{ item.name }}</span>
                <span> &nbsp;&nbsp;&nbsp; </span>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sampleReceiveQuant" :label="h_i18n('3083502563451d766d25bf6bc5a34103')" width="120"></el-table-column>
        <el-table-column prop="sampleReceiveDate" :label="h_i18n('2e85190290afbb526172b2afc62159c2')" width="130">
          <template #default="{ row }">
            <span>{{ time(row.sampleReceiveDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="h_i18n('eca37cb0726c51702f70c486c1c38cf3')" width="130">
          <template #default="{ row }">
            <span>{{ time(row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" :label="h_i18n('a001a226fdc34fd7121f9c4839c759a2')" width="130">
          <template #default="{ row }">
            <span>{{ time(row.updateTime) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
                     v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
                     :total="data.total">
      </el-pagination>
    </h-table-card>
    <el-drawer size="600px" :title="h_i18n('380764036ee6599431fd6bf14f0e8870')" modal-class="drawer_style" :show-close="true" v-model="data.drawerShow" @close="data.drawerShow = false">
      <template #title>
        <div class="titleDrawer">{{ h_i18n('380764036ee6599431fd6bf14f0e8870') }}</div>
      </template>
      <el-row>
        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('6a52ae8d38d65d94a9673129041ca156') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.vendorSendSamplePerson" disabled></el-input>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('0a5b1df588a1e061097183d52c2d585b') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.vendorSendSampleQuant" disabled></el-input>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('195fe52c72f3f8c6be34c497b47c94bc') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.vendorSendSampleWay" disabled></el-input>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('3c016d36581bc71c027386cbf617722f') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.expressNumber" disabled></el-input>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('d7f974be4808f887a05db717fd37ea36') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.prototypeSendDate" disabled></el-input>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('3f35655dd0d0598a1441faad74ac5d40') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.vendorSendSampleDate" disabled></el-input>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('4cc74191055a38ad8996b922a6bfecab') }}</div>
        </el-col>
        <el-col :span="18">
          <div class="image_list_style" :style="{'--height':data.imgHeight}" v-if="receiveData.pictureList.length > 0 && receiveData.pictureList[0].name">
            <div class="image_div_style pointer" v-for="item in receiveData.pictureList" @click="lookPicture(item)" :key="item.name">
              <el-image class="image_style" :src="$filePathSplicing(item.url, 'img')" :alt="item.name">
                <template #error>
                  <div class="image_slot">
                    <picture-one theme="outline" size="24" fill="#CCC"/>
                  </div>
                </template>
              </el-image>

              <!-- <img class="image_style" :src="item.url" :alt="item.name"> -->
            </div>
          </div>
          <div v-else></div>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('f9c946f168fef4b7ac270ad2dee628fb') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.sampleReceiveQuant" disabled></el-input>
        </el-col>

        <!-- <el-col :span="6">
          <div class="left_title_style">收样人</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.sampleReceivePerson" disabled></el-input>
        </el-col> -->
        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('461bf535b637a74b60a2bb48434e7bc7') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="receiveData.sampleReceiveDate" disabled></el-input>
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('0194826fc76658fc273a589852d214c0') }}</div>
        </el-col>
        <el-col :span="18">
          <div style="height:32px;line-height: 32px;">{{ receiveData.status }}</div>
          <!-- <el-input v-model="receiveData.status" disabled></el-input> -->
        </el-col>

        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('b9bca46ff88c72b2d00059ff9b2ed396') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input type="textarea" :rows="2" v-model="receiveData.opinion" disabled></el-input>
        </el-col>
      </el-row>
    </el-drawer>
    <el-drawer size="600px" modal-class="drawer_style" :title="h_i18n('cde14d8fb1c3b27a5fc67c030f98b646')" :show-close="false" v-model="data.sendFlag" @close="closeSendDrawer">
      <template #title>
        <div class="titleDrawer">{{ h_i18n('cde14d8fb1c3b27a5fc67c030f98b646') }}</div>
        <h-button type="primary" @click="sendSubmit" :loading="data.sendSubmitLoading">
          <template #icon>
            <send theme="outline"/>
          </template>{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
        <h-button style="margin-left: 10px" type="warning" @click="closeSendDrawer">
          <template #icon>
            <close theme="outline"/>
          </template>{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
      </template>
      <el-row>
        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('6a52ae8d38d65d94a9673129041ca156') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="postData.vendorSendSamplePerson"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('0a5b1df588a1e061097183d52c2d585b') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="postData.vendorSendSampleQuant" @input="numberFun"></el-input>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="18">
          <div class="dangerColor" style="margin-bottom: 10px;">{{ h_i18n('e56a3f881fb48d3f68ae7cbf578ac285') }}</div>
        </el-col>
        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('195fe52c72f3f8c6be34c497b47c94bc') }}</div>
        </el-col>
        <el-col :span="18">
          <el-radio-group v-model="postData.vendorSendSampleWay" @change="vendorSendSampleWayChange">
            <el-radio :label="h_i18n('705d54db81f6eaf23b9c56eb0b4b40d4')">{{ h_i18n('705d54db81f6eaf23b9c56eb0b4b40d4') }}</el-radio>
            <el-radio :label="h_i18n('98789c2803dd7db3c272916eb1a2afae')">{{ h_i18n('98789c2803dd7db3c272916eb1a2afae') }}</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('3c016d36581bc71c027386cbf617722f') }}</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="postData.expressNumber" :disabled="data.expressNumberFlag"></el-input>
        </el-col>
        <!-- <el-col :span="6">
          <div class="left_title_style">供方样件应送达时间</div>
        </el-col>
        <el-col :span="18">
          <el-input v-model="postData.prototypeSendDate" disabled></el-input>
        </el-col> -->
        <el-col :span="6">
          <div class="left_title_style">{{ h_i18n('4cc74191055a38ad8996b922a6bfecab') }}</div>
        </el-col>
        <el-col :span="18">
          <!-- <div class="image_list_style" v-if="postData.pictureList.length > 0 && postData.pictureList[0].name">
            <div class="image_div_style pointer" v-for="item in postData.pictureList" @click="lookPicture(item)" :key="item.name">
              <img class="image_style" :src="item.url" :alt="item.name">
            </div>
          </div>
          <div v-else></div> -->
          <div class="default-body-item">
            <h-button type="primary" @click="openPlan">
              <template #icon>
                <pic theme="outline"/>
              </template>{{ h_i18n('c2e40619f0ce7fd31e3ac102ead76a6b') }}</h-button>
            <div class="default-body-text dangerColor">
              <div>{{ h_i18n('ec85f2a49644d7316f8d9f277ae6eee3') }}</div>
              <div>{{ h_i18n('1ecf378dffb1567db051d17d0bf314a2') }}</div>
            </div>
            <!-- <div class="default-body-text">2.单个文件不大于30M</div> -->
          </div>
          <div class="image_list_style" :style="{'--height':data.fileListOld.length> 4 ? '152px' : '80px'}">
            <div class="image_div_style pointer" v-for="item in data.fileListOld" @click="lookPicture(item)" :key="item.name">
              <el-image class="image_style" :src="$filePathSplicing(item.url, 'img')" :alt="item.name">
                <template #error>
                  <div class="image_slot">
                    <picture-one theme="outline" size="24" fill="#CCC"/>
                  </div>
                </template>
              </el-image>
            </div>
          </div>
          <!-- <div class="default-body-image-list">
            <div class="default-body-image" v-for="item in data.fileListOld" @click="lookPicture" :key="item">
              <img class="default-body-image-icon" :src="item.url" :alt="item.name">
            </div>
          </div>           -->
        </el-col>
      </el-row>
      <!--上传-->
      <h-dialog :show="data.fileUploadM" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" footer @close="data.fileUploadM=false" width="540px">
        <h-upload @file-change="chooseFile" :max="30" :max-length="10" @error="errorFile" :file-list="data.fileList" h-accept="png,jpg,jpeg,PNG,JPG,JPEG" style="padding:20px;">
          <template #tips>
            <div>{{ h_i18n('f6dd1cd8f40e43fcfb8c34fca40a7777') }}</div>
          </template>
        </h-upload>
        <template #footer>
          <h-button-group align="right">
            <h-button type="primary" @click="uploadFile">{{ h_i18n('e83a256e4f5bb4ff8b3d804b5473217a') }}</h-button>
          </h-button-group>
        </template>
      </h-dialog>
    </el-drawer>
  </h-list-page>
</template>




<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, onMounted ,getCurrentInstance} from 'vue';
import axios from 'axios';
import { useRoute } from 'vue-router';
const route = useRoute();
const { proxy, ctx } = getCurrentInstance();
const receiveData = reactive({ // 收样信息 区分预/整
  vendorSendSamplePerson:'',
  vendorSendSampleQuant:'',
  vendorSendSampleWay:'',
  expressNumber:'',
  prototypeSendDate:'',
  vendorSendSampleDate:'',
  pictureList:[
    {url:'',name:''}
  ],
  sampleReceiveQuant:'',
  sampleReceivePerson:'',
  sampleReceiveDate:'',
  status:'',
  opinion:'',
})
const postData = reactive({
  vendorSendSamplePerson:'',
  vendorSendSampleQuant:'',
  vendorSendSampleWay:'',
  expressNumber:'',
  // prototypeSendDate:'',
  vendorSendSamplePicture:'',
  vendorSendSamplePictureUuid:'',
})
const data = reactive({
  sybList:[],
  SupShow:false,
  planSupBlur:false,
  creationDate:[],
  dateCreateTime:[],
  receiveDate:[],
  mtlList:[],
  mtlLoading:false,
  drawerShow:false,
  btnListOfSqm:[],
  total:0,
  tableLoading:false,
  dataOfTable:[],
  selectedRows:[],
  imgHeight:'80px',
  clickRowList:[],
  fileList:[],
  fileUploadM:false,
  fileListOld:[]
})
const searchData = reactive({
  documentName:'',
  hrTestType:'',
  statusList:'',
  insProNum:'',
  partNumber:'',
  nomenclature:'',
  supplierID:'',
  supplierName:'',
  factoryCode:'',
  sybId:'',

  beginDateCreate:'',
  endDateCreate:'',
  beginDateCreateTime:'',
  endDateCreateTime:'',
  receiveDateBegin:'',
  receiveDateEnd:'',

  pageNo:1,
  pageSize:10,
})
const changeMethod = () => {
  proxy.postThisPageHeight()
}
// 生成收样数据
const createReceiveData = (rowData) =>{
  console.log(rowData)
  receiveData.vendorSendSamplePerson = rowData.vendorSendSamplePerson // 供应商送样人
  receiveData.vendorSendSampleQuant = rowData.vendorSendSampleQuant // 供应商送样送样数量
  receiveData.vendorSendSampleWay = rowData.vendorSendSampleWay // 供应商送样送样方式
  receiveData.expressNumber = rowData.expressNumber // 供应商送样快递单号
  receiveData.prototypeSendDate = rowData.prototypeSendDate // 供方样件应送达时间-送样日期
  receiveData.vendorSendSampleDate = rowData.vendorSendSampleDate // 供应商送样日期
  // 供应商送样送样照片UUID
  let tempUrlList = rowData.vendorSendSamplePictureUuid?.split(',')
  receiveData.pictureList = rowData.vendorSendSamplePicture?.split(',').map((item,index)=>{
    // 供应商送样送样照片
    let url = ''
    let name = item
    url = tempUrlList[index]
    return {url,name}
  })
  receiveData.sampleReceiveQuant = rowData.sampleReceiveQuant // 实收样数量
  receiveData.sampleReceivePerson = rowData.sampleReceivePerson // 收样人
  receiveData.sampleReceiveDate = rowData.sampleReceiveDate // 确认收样时间
  receiveData.status = rowData.status // 收样状态
  receiveData.opinion = rowData.opinion // 收样原因
  for (const key in receiveData) {
    if (!receiveData[key] && key !== 'pictureList') {
      receiveData[key] = '-'
    }else if(!receiveData[key] && key === 'pictureList'){
      receiveData['pictureList'] = []
    }
  }
  if(receiveData.pictureList && receiveData.pictureList.length > 0){
    if(receiveData.pictureList.length < 5){
      data.imgHeight = '80px'
    }else if(receiveData.pictureList.length > 4){
      data.imgHeight = '152px'
    }
  }
  data.drawerShow = true
}
// 送样数量正整数
const numberFun = (v) => {
  console.log(v)
  // 整数
  let re = new RegExp("^[1-9]\\d*$")
  if (!re.test(v)) {
    proxy.$message({ message: h_i18n('7541792be2ecb04b3100734c96afc513'), type: "warning" });
    postData.vendorSendSampleQuant = ""
  } else {
    // postData.vendorSendSampleQuant = v
  }
}
// 选中
const listCheckBoxChange = (rowArr) => {
  data.clickRowList = rowArr
};
// 送样按钮
const sendBtn = () => {
  if(data.clickRowList.length !== 1){
    proxy.info(h_i18n('fa96cdd2c3086ffa5331a524b2080c40'))
    return
  }
  if(data.clickRowList[0].status !== h_i18n('f1728af6ff0737b74b63d2238de7b5ca')){
    proxy.info(h_i18n('6e4bd75844e7326fd476c7910b8a8979'))
    return
  }
  // 预计收样时间
  // postData.prototypeSendDate = data.clickRowList[0].prototypeSendDate
  // ID
  postData.id = data.clickRowList[0].id
  data.sendFlag = true
}
// 关闭送样
const closeSendDrawer = () => {
  data.sendFlag=false
  postData.vendorSendSamplePerson = ''
  postData.vendorSendSampleQuant = ''
  postData.vendorSendSampleWay = ''
  postData.expressNumber = ''
  // postData.prototypeSendDate = data.clickRowList[0].prototypeSendDate
  postData.vendorSendSamplePicture = ''
  postData.vendorSendSamplePictureUuid = ''
  postData.id = undefined
  data.fileListOld = []
}
// 送样方式修改
const vendorSendSampleWayChange = (value) => {
  if(value === '自送'){
    postData.expressNumber = ''
    data.expressNumberFlag = true
  }else{
    data.expressNumberFlag = false
  }
}
// 送样提交
const sendSubmit = () => {
  if(!postData.vendorSendSamplePerson){
    proxy.info(h_i18n('b4dc25d4bbf432fd7ce8f615a7014341'))
    return
  }
  if(!postData.vendorSendSampleQuant){
    proxy.info(h_i18n('bfcc3f6a4cebc0eee6d55808ee9875f9'))
    return
  }
  // 送样数量类型 Number
  postData.vendorSendSampleQuant = Number(postData.vendorSendSampleQuant)
  if(!postData.vendorSendSampleWay){
    proxy.info(h_i18n('c227a14b359c4a27726be203aad7008f'))
    return
  }
  if(postData.vendorSendSampleWay === '快递' && !postData.expressNumber){
    proxy.info(h_i18n('12144de19a1485fa8e9856a45883f5d0'))
    return
  }
  // if(!postData.prototypeSendDate){
  //   proxy.info('请输入预计送样时间')
  //   return
  // }
  if(!postData.vendorSendSamplePicture){
    proxy.info(h_i18n('5d9006a8d1626fb33b39b3fff3cf5772'))
    return
  }
  if(postData.vendorSendSamplePicture && postData.vendorSendSamplePicture.split(',').length < 3){
    proxy.info(h_i18n('de9fdfdefb6300c50b165203f91c90df'))
    return
  }
  if(!postData.id){
    proxy.info(h_i18n('d0e20ecf8e20fd939b75921c0a058aa3'))
    return
  }
  data.sendSubmitLoading = true
  proxy.$http({
    url:'/base/machine/send',
    method:'POST',
    data:{
      ...postData,
      fixConfig:true,
      supplierID:searchData.supplierID,
    }
  }).then(res => {
    if(res.data.code === '200' && res.data.success === true){
      proxy.success(res.data.data || h_i18n('e71a11c45ba66452589198143db14727'))
      getInfo()
    }else{
      proxy.info(res.data.msg || h_i18n('34754ee7a76e74cb442f260ec5ee4753'))
    }

  }).catch(err=>{
    proxy.info(h_i18n('34754ee7a76e74cb442f260ec5ee4753'))
    console.log(err)
  }).finally(()=>{
    data.sendFlag = false
    data.sendSubmitLoading = false
  })
}
// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined
}

// 获取列表
const getInfo = (flag) => {
  if(true == flag){
    searchData.pageNo = 1
  }
  data.tableLoading = true
  proxy.$http({
    url:'/base/machine/listPage',
    method:'POST',
    data:{
      ...searchData,
      fixConfig:true,
      supplierID:searchData.supplierID,
    }
  }).then(res => {
    data.dataOfTable = res.data.data.records
    data.total = res.data.data.total
  }).catch(err=>{
    data.dataOfTable = []
    data.total = 0
    console.log(err)
  }).finally(()=>{
    data.tableLoading = false
  })
}
// 导出
const excleBtn = () => {
  if (data.total > 5000) {
    proxy.warning(h_i18n('5d11f64ddbaa899949fcdecee0185f2d'));
    return;
  }
  if (data.total < 1) {
    proxy.warning(h_i18n('f59ec2b6c282f2c37663f524c2a318c3'));
    return;
  }
  proxy.startLoading(h_i18n('75120b3c39f7df993ac07f2f7dd5f96a'))
  proxy.httpFile({
    url: '/base/machine/sqmExportEcosphereAnalysisList',
    method: 'post',
    data: {
      ...searchData,
      fixConfig: true,
      supplierID: searchData.supplierID,
    },
  } ,h_i18n('294fc9ec099eaf4a65fba653ac8c2f91')).then((res)=>{

  }).catch(err => {

  }).finally(() => {
    proxy.closeLoading()
  })
}
// 图片查看
const lookPicture = (picture)=>{
  if(!picture.url){
    return
  }
  window.open(picture.url)
}

// 两个模糊查询相关
const http = reactive({
  mtlSearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showMtlPlan") {
    if (searchData.partNumber.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.partNumber = row.mtlNo;
  plan.showMtlPlan = false;
};

/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.partNumber.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy
      .$http({
        method: "POST",
        url: "/base/basicData/searchMaterielList",
        headers: { "content-type": "application/json" },
        data: {
          mtlNo: searchData.partNumber,
        },
        cancelToken: http.mtlSearchHttp.token,
      })
      .then((res) => {
        data.mtlList = res.data.data;
      })
      .catch((e) => { }).finally(()=>{
      data.mtlLoading = false
    })
  }
};
// 两个模糊查询结束
// 工厂小微
const getSybList = () => {
  proxy.$http({
    url: "/base/OqcA/listSyb",
    method: "get",
  }).then((res)=>{
    data.sybList = res.data.map(item=>{
      return {valueName: item.departmentName,valueId: item.departmentId}
    })
  }).catch(err=>{
    console.log(err)
  }).finally(()=>{

  })
}
// 列表图片列表
const getRowPicList = (row) => {
  let pictureList = row.vendorSendSamplePicture?.split(',').map((item,index)=>{
    // 供应商送样送样照片
    let url = ''
    let name = item
    // 供应商送样送样照片UUID
    let tempUrlList = row.vendorSendSamplePictureUuid?.split(',')
    url = tempUrlList[index]
    return {url,name}
  })
  return pictureList
}

// 时间范围选择
const TimeChange = (date, { start, end }) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
}

// 文件上传
//打开面板
const openPlan = () => {
  data.fileList = []
  data.fileUploadM = true
  data.fileList = data.fileListOld.map((v, i) => ({...v, status: "success", progress: 100, name: v.name})).filter(v => v.name)
}
//选择文件
const chooseFile = (file, fileList) => {
  data.fileList = fileList
}
const errorFile = (str) => {
  proxy.info(str)
}

//删除文件
//  const removeFile = (file) => {
//     data.fileList = data.fileList.filter(v => v.uid !== file.uid)
//   }
//文件上传
const uploadFile = () => {
  let uploadFileList = data.fileList.filter(v => v.status === "default")
  if (uploadFileList.length === 0) {
    if (data.fileListOld.length !== data.fileList.length) {
      data.fileListOld = data.fileList.map(v => ({name: v.name, url: v.url}))
      data.fileUploadM = false
      return false
    }
    proxy.info(h_i18n('9febf31146d9c96bfde09a4a20dcf17d'))
    return false
  }
  let formData = new FormData()
  uploadFileList.map(v => {
    formData.append('files', v.file)
    v.progress = 50
  })
  return proxy.$http({
    method: 'post',
    url: '/base/fileUpload/uploadToOssSaveUrl',
    headers: {'Content-Type': 'multipart/form-data'},
    data: formData,
    cache: false,
    processData: false,
    contentType: false,
  }).then((res) => {
    if (res.data.code === "0") {
      let resData = res.data.data
      let noList = data.fileList.filter(v => !v.url)
      let hasList = data.fileList.filter(v => v.url)
      data.fileListOld = [...hasList.map(v => {
        return {
          name: v.name,
          url: v.url
        }
      }), ...resData.split(",").map((v, i) => {
        return {
          name: noList[i] ? noList[i].name : `computer${proxy.time()}`,
          url: v
        }
      })]
      uploadFileList.map(v => {
        v.progress = 100
        v.status = "success"
      })
      proxy.success({
        title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
        message: h_i18n('a7699ba73144aad544eb9ac49f82749d'),
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
        callback: (action) => {
          data.fileUploadM = false
        }
      })
      console.log(data.fileListOld)
      // 拼接附件url/name
      postData.vendorSendSamplePicture = ''
      postData.vendorSendSamplePictureUuid = ''
      data.fileListOld.map((v,i) => {
        if(i !== data.fileListOld.length - 1){
          postData.vendorSendSamplePicture += v.name + ','
          postData.vendorSendSamplePictureUuid += v.url + ','
        }else{
          postData.vendorSendSamplePicture += v.name
          postData.vendorSendSamplePictureUuid += v.url
        }
      })

    } else {
      return Promise.reject()
    }
  }).catch((err) => {
    uploadFileList.map(v => {
      v.progress = 100
      v.status = "fail"
    })
    proxy.error(h_i18n('54e5de428ca9d59119d4624706215a4d'))
  })
}
// 文件上传结束
onMounted(()=>{
  if(route.query){
    searchData.supplierID = route.query.supplyCode
    searchData.supplierName = route.query.supplyName
  }
  if(!searchData.supplierID){
    proxy.info(h_i18n('f344099d4f51e518f8d8dd5202797784'))
    return
  }
  if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }
  getSybList()
  getInfo()
})
</script>

<style lang="scss" scoped>
.myMultiple75 :deep(.el-select__tags) {
  padding-left: 75px;
  box-sizing: border-box;
}
</style>

<style lang="scss">
.mtlSelect {
  width: 400px !important;
  max-width: 400px !important;
  position: absolute;
  left: 0;
  z-index: 100;
  top: 34px;
  padding: 12px 16px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 7px 0 rgba(2, 9, 25, 0.12), 0 0px 16px 0 rgba(2, 9, 25, 0.08), 0 9px 28px 0 rgba(2, 9, 25, 0.05);
}
.mtlInput .ant-input-suffix {
  position: relative;
}
.mtlInput .ant-input-clear-icon-has-suffix.ant-input-clear-icon {
  background: #fff;
  z-index: 1;
  width: 14px;
  margin: 0;
}
.mtlInput .h-icon.h-icon-search {
  position: absolute;
  right: 0;
}
.left_title_style{
  height: 45px;
  line-height: 30px;
}
.image_list_style {
  min-height: 90px;
  padding-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: space-between;
  height: var(--height);
  .image_div_style{
    border-radius: 8px;
    margin-right: 10px;
    margin-bottom: 5px;
    .image_style{
      height: 72px;
      width: 72px;
      border-radius: 8px;
      .image_slot{
        height: 72px;
        width: 72px;
        background: #e9e6e6;
        margin: auto;
        text-align: center;
        line-height: 72px;
        span{
          vertical-align: -webkit-baseline-middle;
        }
      }
    }
  }
}
.blue {
  color: #165DFF;
}

.pointer {
  cursor: pointer;
}
.row_pic_style{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width:115px;
}
.row_pic_style:hover{
  white-space: normal;
}
.planHidden {
  display: none;
}
.drawer_style{
  .el-drawer{
    overflow-y: auto;
    .el-drawer__header{
      border-bottom: 1px solid #ccc;
    }
    .titleDrawer {
      height: 50px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      color: #1D2129;
      font-weight: bold;
    }
    .el-drawer__body{
      margin: 0 16px;
    }

  }
  .default-body-item{
    .haier-button{
      margin-bottom: 16px;
    }
    .default-body-text{
      width: 300px;
      position: absolute;
      top: 208px;
      left: 260px;
      font-size: 12px;
    }
  }


}

</style>